import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Mail, MessageCircle, BookOpen, ChevronRight } from "lucide-react";

const HelpRow = ({ icon: Icon, title, subtitle, testid, onClick }) => (
  <button
    type="button"
    data-testid={testid}
    onClick={onClick}
    className="w-full flex items-center gap-3 bg-white border border-[#E2E0D8] rounded-2xl px-4 py-3 hover:bg-[#F5F3ED] transition-colors text-left"
  >
    <div className="w-9 h-9 rounded-xl bg-[#DCEDF0] flex items-center justify-center shrink-0">
      <Icon className="w-4 h-4 text-[#1F5566]" />
    </div>
    <div className="flex-1 min-w-0">
      <div className="font-heading text-sm font-semibold text-[#2D3142]">{title}</div>
      <div className="text-[11px] text-[#8A93A6] truncate">{subtitle}</div>
    </div>
    <ChevronRight className="w-4 h-4 text-[#8A93A6]" />
  </button>
);

const HelpSupport = () => {
  const navigate = useNavigate();
  return (
    <div className="px-5 pt-6 pb-8">
      <button
        onClick={() => navigate(-1)}
        data-testid="help-back-btn"
        className="text-sm text-[#4F5D75] hover:text-[#2D3142] flex items-center gap-2 mb-4"
      >
        <ArrowLeft className="w-4 h-4" /> Back
      </button>

      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
      >
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#8A93A6]">
          Help & Support
        </div>
        <h1 className="font-heading text-3xl font-bold text-[#2D3142] mt-1">
          We're here to help
        </h1>
        <p className="text-sm text-[#4F5D75] mt-2 leading-relaxed">
          Live support and a full help center are on the way. In the meantime,
          here's how to reach us.
        </p>
      </motion.div>

      <div className="mt-6 space-y-3">
        <HelpRow
          icon={Mail}
          title="Email support"
          subtitle="support@qfreshstorage.com — replies within 24h"
          testid="help-row-email"
          onClick={() => { window.location.href = "mailto:support@qfreshstorage.com"; }}
        />
        <HelpRow
          icon={MessageCircle}
          title="Live chat"
          subtitle="Coming soon"
          testid="help-row-chat"
          onClick={() => {}}
        />
        <HelpRow
          icon={BookOpen}
          title="Help center & FAQs"
          subtitle="Coming soon"
          testid="help-row-faq"
          onClick={() => {}}
        />
      </div>
    </div>
  );
};

export default HelpSupport;
